var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalJobIdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H6.5M4 9H6.5M4 11H6.5M8.5 11.5H10C10.8284 11.5 11.5 10.8284 11.5 10V3.07214C11.5 2.31549 10.9367 1.67344 10.1826 1.61085C9.93375 1.59019 9.68409 1.57239 9.43365 1.55746M5.56635 1.55746C5.52322 1.69734 5.5 1.84596 5.5 2C5.5 2.27614 5.72386 2.5 6 2.5H9C9.27614 2.5 9.5 2.27614 9.5 2C9.5 1.84596 9.47678 1.69734 9.43365 1.55746M5.56635 1.55746C5.75517 0.945045 6.32561 0.5 7 0.5H8C8.67439 0.5 9.24483 0.945045 9.43365 1.55746M5.56635 1.55746C5.31591 1.57239 5.06625 1.59019 4.81739 1.61085C4.06333 1.67344 3.5 2.31549 3.5 3.07215V4.5M3.5 4.5H1.25C0.835786 4.5 0.5 4.83579 0.5 5.25V12.75C0.5 13.1642 0.835786 13.5 1.25 13.5H7.75C8.16421 13.5 8.5 13.1642 8.5 12.75V5.25C8.5 4.83579 8.16421 4.5 7.75 4.5H3.5ZM2.5 7H2.505V7.005H2.5V7ZM2.5 9H2.505V9.005H2.5V9ZM2.5 11H2.505V11.005H2.5V11Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalJobIdIcon);
export default __webpack_public_path__ + "static/media/externalJobIdIcon.b2652432f124398e7a105ea28808f481.svg";
export { ForwardRef as ReactComponent };